import axios from 'axios'
import {url} from './config.js'
// let url = 'https://www.nowyousee.cn/'

export async function bget(options){
      return new Promise((resolve,reject)=>{
         axios.get(url+options.url,{
            params:options.data
          })
          .then((res)=>{
             resolve(res)
          }).catch((err)=>{
                reject(err)
         })
      })

}
// export async function bpost(param) {
// 	const {
// 		url,
// 		data
// 	} = param
// 	return req({
// 		url: BASE_URL + url,
// 		method: 'post',
// 		data: data || {}
// 	})
// }

export async function bpost(options){
      return new Promise((resolve,reject)=>{
        axios.post(url+options.url,options.data)
          .then((res)=>{
             resolve(res)
          }).catch((err)=>{
                reject(err)
         })
      })

}



//////////////////
// WEBPACK FOOTER
// ./config/httpRequest.js
// module id = null
// module chunks = 